import { createSelector } from 'reselect';

import { projectsSelector, groupsSelector, environmentTypesSelectorWithoutDev, timePeriodsSelector } from './base';
import { settingsSelector } from './settings';
import { specificOrFirst } from './helpers';

export const summarySettingsSelector = createSelector([settingsSelector], settings => {
    const { total, successful, failed, meanTime, deploymentDuration, failedRatio } = settings.main;
    return {
        total: total.visible && total.active,
        successful: successful.visible && successful.active,
        failed: failed.visible && failed.active,
        meanTime: meanTime.visible && meanTime.active,
        deploymentDuration: deploymentDuration.visible && deploymentDuration.active,
        failedRatio: failedRatio.visible && failedRatio.active
    };
});

export const projectsForSummerySelector = createSelector([projectsSelector], (projects) => [
    ...projects.map(p => ({ ...p, type: 'project' }))
]);

export const projectsAndGroupsMixSelector = createSelector([projectsSelector, groupsSelector], (projects, groups) => [
    ...projects.map(p => ({ ...p, type: 'project' })),
    ...groups.map(g => ({ ...g, type: 'group' }))
]);

const summaryDataSelector = state => {
    const summaries = state.newdashboard.summary.toJS();
    const { total, successful, failed, meanTime, deploymentDuration, failedRatio } = summaries;
    return {
        total,
        successful,
        failed,
        meanTime,
        deploymentDuration,
        failedRatio
    };
};

const getTimePeriod = state => state.newdashboard.summary.get('timePeriod');
export const timePeriodSelector = createSelector([timePeriodsSelector, getTimePeriod], (list, item) => {
    let parsed;
    if (item && item.toJS) {
        parsed = item.toJS();
    }
    if (!parsed || !list.some(p => p.periodName === parsed.periodName)) {
        parsed = list[0];
    }
    return parsed;
});

const getEnvironmentType = state => state.newdashboard.summary.get('environmentType');

export const environmentTypeSelector = createSelector([environmentTypesSelectorWithoutDev, getEnvironmentType], (list, item) => {
    const t = item || list[0];
    return t && t.toJS ? t.toJS() : t;
});

export const summarySelector = createSelector([summarySettingsSelector, summaryDataSelector], (settings, data) => {
    const fields = Object.getOwnPropertyNames(settings);
    return fields.reduce((acc, val) => {
        if (settings[val]) {
            acc[val] = data[val];
        }
        return acc;
    }, {});
});

const getProjectOrGroup = state => state.newdashboard.summary.get('projectOrGroup');
export const summaryProjectOrGroupSelector = createSelector([projectsForSummerySelector, getProjectOrGroup], (list, item) => {
    let parsed;
    if (item && item.toJS) {
        parsed = item.toJS();
    }
    if (!parsed || !list.some(p => p.id === parsed.id)) {
        parsed = list[0];
    }
    return parsed;
});

export const summaryGridSizeSelector = createSelector([summarySettingsSelector], settings => {
    const gridSize = (settings.total ? 1 : 0)
        + (settings.successful ? 1 : 0)
        + (settings.failed ? 1 : 0)
        + (settings.meanTime ? 1 : 0)
        + (settings.deploymentDuration ? 1 : 0)
        + (settings.failedRatio ? 1 : 0);
    return gridSize;
});

export const summaryLoadingSelector = state => state.newdashboard.summary.get('loading');
export const timePeriodInfoSelector = state => state.newdashboard.summary.get('timePeriodInfo').toJS();



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/selectors/summary.js